if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      /**
       * @type {HTMLFormElement}
       */
      this.formElement = this.querySelector('form[id^="product-form-"]');
      /**
       * @type {HTMLButtonElement}
       */
      this.addButton = this.formElement.querySelector(
        "[data-add-to-cart-button]",
      );

      // Add event listener to the form submission
      this.formElement.addEventListener("submit", this.handleSubmit.bind(this));
    }

    /**
     * Handles the product form submission
     * @param {SubmitEvent} event
     */
    async handleSubmit(event) {
      event.preventDefault();

      this.addButton.disabled = true;

      await this.addToCart();

      this.addButton.disabled = false;
    }

    buildCartBody() {
      this.cartBody = {
        items: [],
      };

      const checkedSubscriptionRadio = document.querySelector(
        "[name='subscription_type']:checked",
      );
      const subscriptionType = checkedSubscriptionRadio.value;

      if (subscriptionType === "none") {
        console.log("No subscription");
      } else {
        this.cartBody.items.push({
          id: checkedSubscriptionRadio.dataset.variantId,
          selling_plan: subscriptionType,
          quantity: 1,
        });
      }

      // Add the product to the cart body
      this.cartBody.items.push({
        id: this.formElement.querySelector("input[name='id']").value,
        quantity: 1,
      });

      return this.cartBody;
    }

    async addToCart() {
      const cartBody = this.buildCartBody();

      const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartBody),
      });

      if (res.ok) {
        const event = new CustomEvent("refresh-toggle-cart-drawer");
        window.dispatchEvent(event);
      } else {
        console.error("Failed to add to cart");
      }
    }
  }
  customElements.define("product-form", ProductForm);
}
